import { render, staticRenderFns } from "./driverAdmin.vue?vue&type=template&id=148fc2f0&scoped=true"
import script from "./driverAdmin.vue?vue&type=script&lang=js"
export * from "./driverAdmin.vue?vue&type=script&lang=js"
import style0 from "./driverAdmin.vue?vue&type=style&index=0&id=148fc2f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148fc2f0",
  null
  
)

export default component.exports